import { render, staticRenderFns } from "./rewardsList.vue?vue&type=template&id=30020247&scoped=true"
import script from "./rewardsList.vue?vue&type=script&lang=js"
export * from "./rewardsList.vue?vue&type=script&lang=js"
import style0 from "./rewardsList.vue?vue&type=style&index=0&id=30020247&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30020247",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30020247')) {
      api.createRecord('30020247', component.options)
    } else {
      api.reload('30020247', component.options)
    }
    module.hot.accept("./rewardsList.vue?vue&type=template&id=30020247&scoped=true", function () {
      api.rerender('30020247', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/credit/report/pdfDataInfo/MemberInfo/rewardsList.vue"
export default component.exports